import * as Factory from 'factory.ts'

import { type GetIntegrationStatusResponse } from '@webapp/api/IntegrationsAPI'

export const IntegrationStatusMock =
  Factory.Sync.makeFactory<GetIntegrationStatusResponse>({
    integration_connections: {
      netsuite_v2: false,
      punchout: false,
      quickbooks: false,
      slack: false,
      stripe: false,
      financial_account: false,
      cad_payment_source: false,
    },
    slack_integration: {
      slack_redirect_url: '',
      slack_state: '',
    },
  })
